import { Currency } from '@/core/currency/interfaces';

const IDR: Currency = {
    name: 'Indonesian Rupiah',
    demonym: 'Indonesian',
    majorSingle: 'Rupiah',
    majorPlural: 'Rupiah',
    codeNumeric: '360',
    symbol: 'Rp',
    symbolNative: 'Rp',
    minorSingle: 'Sen',
    minorPlural: 'Sen',
    ISOdigits: 2,
    decimals: 0,
    numToBasic: 100,
    code: 'IDR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default IDR;
